import { axiosV2, getError, getResponse, settings } from '../../helpers/UtilsHelper';

const { app } = settings;
const { backend } = app;
const { urls } = backend;

export const SaleService = {
    /**
     * Get sales by user or perform post query
     * @param {Object} params
     * @param {string} params.token
     * @param {Object} params.dataObj
     * @param {string} params.subMethod
     * @returns {Promise<Object>}
     */
    postQuery: async ({
        token = '',
        dataObj = {},
        subMethod = ''
    } = {}) => {
        const currentMethod = 'SaleService.postQuery';
        let response = getResponse({ type: 0 });
        try {
            const headers = { authorization: `bearer ${token}` };
            response = await axiosV2?.post({
                url: `${urls?.url}${urls?.apiV1}${urls?.sales}/`,
                data: dataObj,
                headers,
                subMethod: currentMethod
            });
            return response;
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
    },

    /**
     * Delete sale by id
     * @param {Object} params
     * @param {string} params.id
     * @param {string} params.token
     * @param {string} params.subMethod
     * @returns {Promise<Object>}
     */
    deleteById: async ({
        id = '',
        token = '',
        subMethod = ''
    } = {}) => {
        const currentMethod = 'SaleService.deleteById';
        let response = getResponse({ type: 0 });
        try {
            const headers = { authorization: `bearer ${token}` };
            response = await axiosV2?.delete({
                url: `${urls?.url}${urls?.apiV1}${urls?.sales}/${id}`,
                headers,
                subMethod: currentMethod
            });
            return response;
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
    },
};
